import React from 'react';

import * as S from './styles';

// Types
import { HTMLAttributes, ReactNode } from 'react';

type Props = {
  children: ReactNode;
} & HTMLAttributes<HTMLHeadingElement>;

const StaticPageTitle = ({ children, ...rest }: Props) => {
  return <S.Title {...rest}>{children}</S.Title>;
};

export default StaticPageTitle;
